import { render, staticRenderFns } from "./TranslationMenu.vue?vue&type=template&id=561b7111&scoped=true&"
import script from "./TranslationMenu.vue?vue&type=script&lang=js&"
export * from "./TranslationMenu.vue?vue&type=script&lang=js&"
import style0 from "./TranslationMenu.vue?vue&type=style&index=0&id=561b7111&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561b7111",
  null
  
)

export default component.exports